// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment'; 

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>, 
  next: HttpHandlerFn      
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const authToken = authService.getToken();
  const apiUrl = environment.apiUrl; 

  if (!req.url.startsWith(apiUrl)) {
    return next(req);
  }

  const excludedApiEndpoints = [
    '/register', 
    '/login'  
  ];

  const isExcludedEndpoint = excludedApiEndpoints.some(endpoint => req.url === apiUrl + endpoint);

  if (isExcludedEndpoint) {
    return next(req);
  }

  if (authToken) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
    });
    return next(authReq);
  }

  return next(req);
};